/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_IntroInputs */

const en_admin_embed_intro = /** @type {(inputs: Admin_Embed_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the complete HTML code for the widget you want and paste it where it should appear on your website. The links point to this platform. If automatic copying is unavailable, the code will be selected; copy it using Ctrl+C or ⌘C.`)
};

const de_admin_embed_intro = /** @type {(inputs: Admin_Embed_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren Sie den vollständigen HTML-Code des gewünschten Widgets und fügen Sie ihn an der gewünschten Stelle Ihrer Webseite ein. Die Links verweisen auf diese Plattform. Falls das automatische Kopieren nicht möglich ist, wird der Code markiert; kopieren Sie ihn dann mit Strg+C bzw. ⌘C.`)
};

/**
* | output |
* | --- |
* | "Copy the complete HTML code for the widget you want and paste it where it should appear on your website. The links point to this platform. If automatic copyi..." |
*
* @param {Admin_Embed_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_intro = /** @type {((inputs?: Admin_Embed_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_intro(inputs)
	return en_admin_embed_intro(inputs)
});